import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import {
  AccountCircle as UserIcon,
  Lock as LockIcon,
} from '@mui/icons-material';

const ProfileRow = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 500 }}>
      {value || '-'}
    </Typography>
  </Box>
);

const ProfileDialog = ({ open, onClose, authenticatedUser, onChangePassword }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <UserIcon color="primary" />
          <Typography variant="h6">Profile</Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <ProfileRow label="Full Name" value={authenticatedUser?.full_name || authenticatedUser?.name} />
        <ProfileRow label="Email" value={authenticatedUser?.email} />
        <Box sx={{ mb: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Role
          </Typography>
          <Box sx={{ mt: 0.75 }}>
            <Chip
              label={authenticatedUser?.role || 'user'}
              size="small"
              color="primary"
              variant="outlined"
            />
          </Box>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body2" color="text.secondary">
          Need to update your credentials? Use the password change flow below and confirm with your current password.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose}>Close</Button>
        <Button
          variant="contained"
          startIcon={<LockIcon />}
          onClick={onChangePassword}
        >
          Change Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfileDialog;
